import React, { Suspense, useEffect, useRef, useState } from "react"
import { Text } from "drei"
import { useFrame } from "react-three-fiber"
import Background from "./Background"
import Crystals from "./Crystals"
import Effects from "./Effects"
import { Vector3 } from "three"
import FboParticles from "./Particles"

const lookAt = new Vector3(0, 0, 0)
const mouseV = new Vector3(0, 0, 0)

function useMouse() {
  const mouse = useRef({ x: 0, y: 0 })

  useEffect(() => {
    document.addEventListener("mousemove", onMouseMove, true)

    function onMouseMove(event) {
      mouse.current.x = (-0.5 + event.x / window.innerWidth) * 2
      mouse.current.y = (-0.5 + event.y / window.innerHeight) * 2
    }

    return () => {
      document.removeEventListener("mousemove", onMouseMove)
    }
  }, [])

  return mouse
}

function Texts() {
  const group = useRef()

  useFrame((state) => {
    const t = state.clock.getElapsedTime()
    group.current.position.x = Math.sin(t) * 4
  })
  return (
    <group ref={group}>
      {/*N*/}
      <Text position={[0, 8, -30]} rotation={[-Math.PI / 2, 0, 0]} fontSize={5}>
        cxciii
      </Text>

      {/*S*/}
      <Text position={[0, -8, -30]} rotation={[Math.PI / 2, 0, 0]} fontSize={5}>
        cxciii
      </Text>

      {/*W*/}
      <Text position={[-8, 0, -30]} rotation={[0, Math.PI / 2, 0]} fontSize={5}>
        cxciii
      </Text>

      {/*E*/}
      <Text position={[8, 0, -30]} rotation={[0, Math.PI / 2, 0]} fontSize={5}>
        cxciii
      </Text>

      {/* FRONT */}
      <Text position={[0, 0, -30]} fontSize={1}>
        cxcii
      </Text>
    </group>
  )
}

export default function Scene() {
  const mouse = useMouse()
  const [text, setText] = useState("cxciii")

  useFrame(({ camera }) => {
    mouseV.x = mouse.current.x * 0.5
    mouseV.y = -mouse.current.y * 0.2
    lookAt.lerp(mouseV, 0.1)
    // camera.lookAt(lookAt)
  })

  return (
    <>
      <Suspense fallback={null}>
        <ambientLight />
        {/* <Background /> */}
        <Texts />
        <FboParticles />
        {/* <Crystals /> */}
      </Suspense>
    </>
  )
}
